import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import '../../../App.css';



export default function AlertsModal(props) {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('body');

  const notifications = [
    {
      new: true
    },
    {
      new: true
    },
    {
      new: false
    },
    {
      new: true
    },
    {
      new: true
    },
    {
      new: false
    },
    {
      new: false
    },
    {
      new: false
    },
  ]


  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {

    if (props.open) {

      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (

    <div>

      <Dialog
        open={props.open}
        onClose={props.handleClose}
        scroll={scroll}
        sx={{

        }}
        BackdropProps={{
          style: {
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(3px)'
          }
        }}
        PaperProps={{
          style: {
            // backgroundColor: 'transparent',
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            borderBottomLeftRadius: 15,
            borderBottomRightRadius: 15,
            // borderStyle: 'solid',
            // borderWidth: '0px 2px 2px 0px',
            // borderColor: '#59776F',
            boxShadow: '#00000055 0px 6px 12px',
          },
        }}
        style={{

        }}
        fullWidth={true}
        maxWidth={'lg'}

        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >

        <DialogContent dividers={false} sx={{
          padding: 0,
          overflowX: 'hidden',
          backgroundColor: 'transparent'

        }}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <div style={{
              width: '100%',
              backgroundColor: '#F8F8F8',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              borderBottomLeftRadius: 15,
              borderBottomRightRadius: 15,
              borderStyle: 'solid',
              borderWidth: '0px 2px 2px 2px',
              borderColor: props.color ? props.color : '#59776F',

            }}>
              <div style={{

                border: props.color ? '5px solid ' + props.color : '5px solid #59776F',
                // borderRadius:20,
                borderTopLeftRadius: 15,
                borderTopRightRadius: 15,
                background: props.color ? props.color : '#59776F',
                height: '24px',
                marginTop: 0,

                width: '100.1%'
              }}>

              </div>
              <div style={{ display: 'flex', marginTop: 20, flexDirection: 'row', width: '100%', marginBottom: 20 }}>
                <div style={{ flex: 1, }}>
                </div>
                <div style={{ flex: 1, justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'space-between' }}>
                    <h3 style={{ flex: 1, textAlign: 'center', color: props.color ? props.color : '#52676F' }}>
                      لديك اشعارات جديدة من وزارة الصحة
                    </h3>
                    <div style={{

                      border: props.color ? '2px solid ' + props.color : '2px solid #2E5266',
                      borderRadius: '12px',
                      background: props.color ? props.color : '#2E5266',
                      height: '1px',

                    }}>

                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, justifyContent: 'end', display: 'flex', alignItems: 'center' }}>
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    paddingLeft: 20
                  }}>
                    <IconButton onClick={() => { props.handleClose() }} aria-label="اغلاق">
                      <CloseIcon style={{ fontSize: 60, color: props.color ? props.color : '#52676F' }} />
                    </IconButton>
                  </div>
                </div>
              </div>
              {notifications.map(notification => {
                return (
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: '50px', paddingLeft: '50px', paddingTop: '10px', paddingBottom: '10px' }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
                     
                        <Typography variant="h6" component="h1" sx={{
                          color: '#10406B',
                          fontFamily: "'Tajawal', sans-serif",
                          fontStyle: 'bold',
                          textAlign: 'right'
                        }} >
                          2022/05/14
                        </Typography>
                        {notification.new?
                        <>
                        <div style={{
                          width:'20px',
                          alignSelf:'center',
                          marginRight:'5px',
                          background: props.color ? props.color : '#2E5266',
                          height: '0.5px',

                        }}>
                          </div>
                          <span style={{
                            backgroundColor:props.color ? props.color : '#2E5266',
                            color:"#FFFFFF",
                            borderRadius:'100px',
                            marginRight:'5px',
                            paddingRight:8,
                            paddingLeft:8,
                            paddingTop:3,
                            paddingBottom:0
                            }}>
                            جديد
                          </span>
                      
                        </> 
                        :null}
                      

                    </div>

                    <Typography paragraph={true} component="p" sx={{
                      color: '#10406B',
                      fontFamily: "'Tajawal', sans-serif",
                      fontStyle: 'normal',
                      marginTop: '10px',
                      textAlign: 'justify',
                      textJustify: 'inter-word'
                    }} >
                      عندك اشعار جديد من وزارة الصحة يكولون سدد الي عليك لا نعزلك ونكطع رزقك ونخليك
                      تروح يم أبو احمد أبو الأسواق تطلب منه بالدين وهو ميقبل ينطيك لان يأخذ من جهزني وجهزني ميقبل اجل.
                      </Typography>
                      <div style={{
                          width:'40%',
                          alignSelf:'center',
                          
                          background: props.color ? props.color : '#2E5266',
                          height: '0.5px',

                        }}>
                      </div>
                  </div>

                )
              })}

            </div>

          </DialogContentText>
        </DialogContent>

      </Dialog>
    </div>

  );
}
